import React, { useEffect } from "react";
import ScreenCreateGuide from "./CreateGuitde";
import { useParams } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { getData } from "../libs/firebase/firestore/getData";
import { useNavigateToTop } from "../libs/useNavigateToTop";

export const ScreenEditGuide = () => {
    
  const navigate = useNavigateToTop();

    
  const { guideId } = useParams();
  
  const currentUser = getAuth().currentUser;
  // state for loading
    const [loading, setLoading] = React.useState(true);

  // state to hold bonsai guide data
    const [bonsaiGuide, setBonsaiGuide] = React.useState(null);

  useEffect(() => {
    
    getData(`bonsai-guides/${guideId}`, (bonsaiGuideData) => {
        setBonsaiGuide(bonsaiGuideData);
        setLoading(false);
      });
    }
    , []);

    // CHeck user is author
    if (currentUser){
        if (currentUser.uid !== bonsaiGuide?.userId){
            navigate(-1);
        }
    }
    if (!currentUser){
        navigate(-1);
    }


    return (
        <ScreenCreateGuide
        bonsaiGuideData={bonsaiGuide}
        guideId={guideId}
        
        />
    );
    }